import { Skeleton, SkeletonProps } from 'grommet';

type Props = object & SkeletonProps;

const TextInputSkeleton = ({ width = 'fill', height = '3rem', round = 'xsmall',  ...rest }: Props) => {
  return <Skeleton width={width} height={height} round={round} {...rest}/>;
};

export default TextInputSkeleton;
